module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Heavy.0c486c46.ttf";